import { useGetDealTrackerDataQuery } from "../../../store/apiSlices/dealTracker";
import { UsersIcon } from "../../Icons";
import DealsTable from "./DealsTable";

export default function DealsTableList() {
  const { data, isLoading, isFetching } = useGetDealTrackerDataQuery();

  if (isLoading && !data) return <TableSkeleton />;

  if (!data) return <p className="text-center text-gray-500">No data found!</p>;

  const accessControlTables = Object.values(
    data?.access_control_data ?? {},
  ).flat();

  if (!accessControlTables.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-gray-300 rounded-lg bg-gray-50">
        <UsersIcon className="size-10 text-gray-300 mb-3" />

        <h3 className="text-sm font-semibold text-gray-800">
          No shared sheets
        </h3>

        <p className="text-xs text-gray-500 mt-1 max-w-xs">
          When someone shares a deal tracker table with you, it will appear
          here.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {accessControlTables.map((table) => {
        const resolvedTable =
          table.shared === "editor" ? structuredClone(table) : table;

        return (
          <DealsTable
            key={table.id}
            table={resolvedTable}
            isFetching={isFetching}
          />
        );
      })}
    </div>
  );
}

function TableSkeleton() {
  return (
    <div className="animate-pulse h-[81px] bg-slate-300 rounded-xl mb-8" />
  );
}
